import { ApiEndpoints } from "@shared/api/api-endpoints";
import { Choice } from "./history/types";
import { communicationApiClient } from "@shared/api/clients/apiClientFactory";
import { transformJsonToObject } from "@shared/utils/jsonToObjectTransformer";

export const getNotificationChoices = async (
  choice: string
): Promise<Choice[]> => {
  const url = ApiEndpoints.createUrlWithPathVariables(
    "communication",
    "choices",
    [choice]
  );
  const response = await communicationApiClient.get(url);
  return transformJsonToObject<Choice[]>(response?.data.result);
};

// Add your feature-specific API calls here
export const uxApi = {
  // Define your API methods
  getNotificationChoices,
};
